import React, { useState } from 'react'
import {
  Box, IconButton, InputAdornment,
  Link,
  OutlinedInput
} from '@mui/material'
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'
import { authInputSx, AuthFieldLabel } from './InputFieldWithLabel';

const PasswordFieldWithLabel = ({
  id,
  label,
  placeholder,
  autoComplete = "current-password",
  onEnterKey,
  onValueChange,
  subText,
  subTextUrl,
  onSubTextClick,
}) => {

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box sx={{ width: "100%" }}>
      <AuthFieldLabel
        htmlFor={id}
        action={subText &&
          <Link
            {...(onSubTextClick
              ? { component: "button", type: "button", onClick: onSubTextClick }
              : { href: subTextUrl })}
            variant="body2" underline="hover" sx={{ fontFamily: "inherit", fontSize: 13, fontWeight: 500, color: "#4DA3FF" }}>
            {subText}
          </Link>
        }
      >
        {label}
      </AuthFieldLabel>

      <OutlinedInput
        id={id}
        name={id}
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        autoComplete={autoComplete}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="small"
              sx={{ color: "rgba(255, 244, 232, 0.5)", "&:hover": { color: "rgba(255, 244, 232, 0.85)" } }}
            >
              {showPassword ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}
            </IconButton>
          </InputAdornment>
        }
        sx={authInputSx}
        onChange={(event) => { onValueChange(event.target.value) }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && onEnterKey) {
            onEnterKey();
          }
        }}
      />
    </Box>
  )
}

export default PasswordFieldWithLabel
